import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import { SgdsMasthead } from "@govtechsg/sgds-masthead-react";

import Navbar from "../../Components/NavbarComponent";
import FooterComponent from "../../Components/FooterComponent";
import SideNavComponent from "../../Components/SideNavComponent";
import MastheadAnnouncement from '../../Components/MastheadAnnouncement'

import Endpoint from "../../Components/Endpoint";

const SearchServices = () => {
  const location = useLocation();

  const endpointreturn = (id) => {
    const endpt_elem = {
      page_section: "search",
      method: "GET",
      endpoint: "/api/common/elastic/search",
      sampleRequest:
        "/api/common/elastic/search?searchVal=200640&returnGeom=Y&getAddrDetails=Y&pageNum=1",
      sampleResponse:
        '{\n  "found": 1,\n  "totalNumPages": 1,\n  "pageNum": 1,\n  "results": [\n    {\n      "SEARCHVAL": "640 ROWELL ROAD SINGAPORE 200640",\n      "BLK_NO": "640",\n      "ROAD_NAME": "ROWELL ROAD",\n      "BUILDING": "NIL",\n      "ADDRESS": "640 ROWELL ROAD SINGAPORE 200640",\n      "POSTAL": "200640",\n      "X": "30381.1007417506",\n      "Y": "32195.1006872542",\n      "LATITUDE": "1.30743547948389",\n      "LONGITUDE": "103.854713903431",\n      "LONGTITUDE": "103.854713903431"\n    }\n  ]\n}',
    };

    const pythonCode = `import requests
      \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
      \nheaders = {"Authorization": "**********************"}
      \nresponse = requests.get(url, headers=headers)
      \nprint(response.text)`;

const jsCode = `const url = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}";
const authToken = '**********************';  // Replace with your access token

fetch(url, {
  method: '${endpt_elem.method}',
  headers: {
    'Authorization': \`\${authToken}\`,  // API token for authorization
  }
})
.then(response => response.json())  // Parse response as JSON
.then(data => console.log(data))     // Log the data to the console
.catch(error => console.error('Error:', error));  // Log any errors`;

    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const { state } = location;
  const [activeKey, setActiveKey] = useState("");
  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };
  useEffect(() => {
    if (state === null) {
      clickButton("0");
    } else {
      clickButton(location.state.toString());
    }
  }, [state]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>

      <Helmet>
        <title>Instant Address Lookup with Geolocation and Coordinates | OneMap API</title>
        <meta
          name="description"
          content="Utilize OneMap's Search API to instantly obtain address information for roads, buildings, and Points of Interest (POI) in Singapore. This API provides both latitude, longitude, and x,y coordinates for entered search values. Ideal for web forms and applications that require real-time address verification and localized search solutions. Explore the query parameters and integrate the API for seamless geospatial data retrieval."
        />
      </Helmet>
      <MastheadAnnouncement/>
      <Navbar />
      <div className="row qx-0 mb-5 position-relative">
        <div className="col-1 d-md-none d-inline">
          <div
            className="btn btn-primary d-md-none position-fixed sideBarBtn"
            onClick={(e) => {
              handleCollapse();
              if (isCollapsed) {
                window.scrollTo(0, 0);
              }
            }}
          >
            Show Side Bar
          </div>
        </div>

        <div
          className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? "collapse" : ""
          }`}
        >
          <SideNavComponent />
        </div>

        <div className="col-12 col-md-9 qx-0 px-3">
          <>
            <div
              id="om-search-section"
              className="om-search-section"
              style={{ minHeight: "510px" }}
            >
              <h1 style={{ fontSize: "32px" }} id="search">
                Search
              </h1>
              <p
                style={{
                  alignItems: "center",
                  marginTop: "0px",
                  fontSize: "14px",
                }}
              >
                This API enables users to obtain address information for roads
                and buildings, etc. This API is great for web forms or
                application that can benefit from instant address verification
                or solutions that want localised POI.
              </p>
              <p>
                This API takes a text input which can be a building name, road name, bus stop number, or postal code; for example: "Revenue House" or "307987". It returns address information including both latitude, longitude, and x, y coordinates, based on the text input and sorts the results according to their estimated relevance.</p>
              <h3 class="om-reverseGeocode-err"><strong class="slate-bold">Possible Error Responses</strong></h3>
              <p>400 - Parameter searchVal is invalid.</p>

              <p>400 - Please state whether you want to return the geometry. (Y-Yes/N-No)</p>

              <p>400 - Please state whether you want to return the address. (Y-Yes/N-No)</p>

              <p>400 - Please state a valid page number.</p>
              
              <p>403 - Access Forbidden. GET access to component 'xxx' of service 'xxx' is not allowed by this user's role.</p>

              <p>429 - API limit exceeded.</p>

              <div class="om-theme-wrapper" style={{'margin-top':'20px'}}><div class="om-theme"><h4 class="om-theme-header">HEADER PARAMETERS</h4></div><div class="om-theme-items"><div class="om-theme-item"><div class="label-method">Authorization<span class="label-type">string</span><span class="label-required">Required</span></div><div class="om-reverseGeocode-desc"><p>API token provided by the Authentication Service.</p></div></div></div></div>

              <div className="om-search-wrapper"></div>
              <div className="om-search-wrapper">
                <div className="om-search">
                  <h4 className="om-search-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-search-items">
                  <div className="om-search-item">
                    <div className="label-method">
                      searchVal
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-search-desc">
                      <p>Keywords entered by users to filter the results</p>
                    </div>
                  </div>
                  <div className="om-search-item">
                    <div className="label-method">
                      returnGeom
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-search-desc">
                      <p>
                        Values: Y, N . Enter Y if user wants the geometry value
                        returned.
                      </p>
                    </div>
                  </div>
                  <div className="om-search-item">
                    <div className="label-method">
                      getAddrDetails
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-search-desc">
                      <p>
                        Values: Y, N . Enter Y if user wants address details
                        returned.
                      </p>
                    </div>
                  </div>
                  <div className="om-search-item">
                    <div className="label-method">
                      pageNum
                      <span className="label-type">integer</span>
                    </div>
                    <div className="om-search-desc">
                      <p>
                        Optional. Specifies the page to retrieve search results.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* bef header params */}
              <Endpoint {...endpointreturn("search")} />
            </div>
          </>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};
export default SearchServices;
